import { render } from "./CancelIcon.vue?vue&type=template&id=158863d6"
import script from "./CancelIcon.vue?vue&type=script&lang=js"
export * from "./CancelIcon.vue?vue&type=script&lang=js"
script.render = render

export default script